import React, { useCallback } from 'react';
import { isFalse } from '@/utils';
import Check from '@/components/feature/icon/Check';
import Flexbox from '@/components/common/Flexbox';
interface SingleCheckboxProps<T = any> {
  options: Option<T>[];
  value?: T;
  onChange: (value: T | undefined) => void;
  cancelable?: boolean;
  noTopBorder?: boolean;
  testIdPrefix?: string;
}
export const SingleCheckbox: React.FC<SingleCheckboxProps> = ({
  options,
  value,
  onChange,
  cancelable,
  noTopBorder,
  testIdPrefix = ''
}) => {
  const handleCheckboxChange = useCallback((v: string) => {
    if (!cancelable && value === v) return;
    onChange(value === v ? undefined : v);
  }, [options, value, onChange]);
  return <Flexbox direction={'column'} data-sentry-element="Flexbox" data-sentry-component="SingleCheckbox" data-sentry-source-file="SingleCheckbox.tsx">
      {!noTopBorder && <div className={'border-t border-grey5 w-full mb-3'} />}
      {options.map(({
      key,
      label,
      active = true
    }) => <React.Fragment key={key}>
          {isFalse(active) ? null : <div>
              <Flexbox onClick={() => handleCheckboxChange(key)} align={'center'} data-test-id={`${testIdPrefix}single-checkbox-option-${key}`} className={'space-x-2'}>
                <Check variant={'circle'} checked={value === key} />
                <span>{label}</span>
              </Flexbox>
              <div className={'border-t border-grey5 w-full my-3'} />
            </div>}
        </React.Fragment>)}
    </Flexbox>;
};